import { format, subDays, subHours, subWeeks } from 'date-fns';

export function generateFilterPeriod(selectedPeriod) {
  let filterPeriod = { ...selectedPeriod };
  switch (selectedPeriod.period) {
    case 'h':
      filterPeriod['startDate'] = format(
        subHours(new Date(), 1),
        'yyyy-MM-dd HH:mm'
      );
      filterPeriod['endDate'] = format(new Date(), 'yyyy-MM-dd HH:mm');
      break;
    case '3h':
      filterPeriod['startDate'] = format(
        subHours(new Date(), 3),
        'yyyy-MM-dd HH:mm'
      );
      filterPeriod['endDate'] = format(new Date(), 'yyyy-MM-dd HH:mm');
      break;
    case 'd':
      filterPeriod['startDate'] = format(subDays(new Date(), 1), 'yyyy-MM-dd');
      filterPeriod['endDate'] = format(new Date(), 'yyyy-MM-dd');
      break;
    case '3d':
      filterPeriod['startDate'] = format(subDays(new Date(), 3), 'yyyy-MM-dd');
      filterPeriod['endDate'] = format(new Date(), 'yyyy-MM-dd');
      break;
    case 'w':
      filterPeriod['startDate'] = format(subDays(new Date(), 7), 'yyyy-MM-dd');
      filterPeriod['endDate'] = format(new Date(), 'yyyy-MM-dd');
      break;
    default:
      break;
  }
  return filterPeriod;
}

export function generateFilterPeriodHeatmap(selectedPeriod) {
  let statePeriod = {
    ...selectedPeriod.statePeriod,
    period: selectedPeriod.period,
  };

  switch (selectedPeriod.period) {
    case 'h':
      statePeriod['startDate'] = subHours(new Date(), 1);
      statePeriod['endDate'] = new Date();
      break;
    case '3h':
      statePeriod['startDate'] = subHours(new Date(), 3);
      statePeriod['endDate'] = new Date();
      break;
    case 'd':
      statePeriod['startDate'] = subDays(new Date(), 1);
      statePeriod['endDate'] = new Date();
      break;
    case '3d':
      statePeriod['startDate'] = subDays(new Date(), 3);
      statePeriod['endDate'] = new Date();
      break;
    case 'w':
      statePeriod['startDate'] = subDays(new Date(), 6);
      statePeriod['endDate'] = new Date();
      break;
    default:
      break;
  }
  return statePeriod;
}
